import { ChatView, RootElementProvider } from '@superbar-ui';
import { NuqsAdapter } from 'nuqs/adapters/react';

interface LibProps {
  rootElement: HTMLElement;
}

export function Lib({ rootElement }: LibProps) {
  return (
    <RootElementProvider value={rootElement}>
      <NuqsAdapter>
        <div
          className="caddietw-w-full caddietw-flex caddietw-justify-center main-container caddie-style-root"
          id={'caddie-style-root'}
          style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: '16px',
          }}
        >
          <div
            id="container"
            className="caddie-container caddietw-w-full caddietw-box-border caddietw-flex caddietw-justify-center caddietw-items-center"
          >
            <ChatView />
          </div>
        </div>
      </NuqsAdapter>
    </RootElementProvider>
  );
}

export default Lib;
